import React, { useState } from 'react';
import Calendar from 'react-calendar';
import styled from 'styled-components';

import { LocationAutocomplete } from './LocationAutocomplete';

// TODO: Think through how to pull from existing stores
// save it to a store schema
// make it a favorite
// then attacH to a userStore schema

export function NewItemListHeader({
  address,
  handleAddressChange,
  handleAddressSearch,
  handleAddressSelect,
  addressList,
  calendarChange,
  calendarValue
}) {
  const [calendarOpen, togggleCalendar] = useState(false);

  const calendar = e => {
    e.preventDefault();
    togggleCalendar(!calendarOpen);
  };

  return (
    <Header>
      <LocationAutocomplete
        value={address}
        onChange={handleAddressChange}
        onSearch={handleAddressSearch}
        handleAddressSelect={handleAddressSelect}
        addressList={addressList}
      />
      <CalendarWrapper>
        <h4>Shopping date</h4>
        <Calendar onChange={calendarChange} value={calendarValue} />
      </CalendarWrapper>
    </Header>
  );
}

const Header = styled.div`
  margin-bottom: 20px;
`;

const CalendarWrapper = styled.div`
  margin-top: 30px;

  .react-calendar {
    width: 100%;
    border-radius: 8px;
    border: none;
    box-shadow: 0px 10px 20px rgba(0, 0, 0, 46%);
    margin-bottom: 40px;
    padding: 10px;
  }
`;
